import { STATUS_CODE } from '@kc-console/core';

import type { BaseState, Env, ServiceAppState } from '@kc-console/context';

export const INITIAL_DEFAULT_STATE: ServiceAppState = {
  status: STATUS_CODE.OK,
  redirect: null,
  env: (process.env.KC_ENV as Env) || 'stage',
  bffEndpoint: process.env.KC_BFF_ENDPOINT || '',
  iamEndpoint: process.env.KC_IAM_ENDPOINT || '',
  iamSSREndpoint: process.env.KC_IAM_SSR_ENDPOINT || '',
  error: null,
  ssrConfig: null,
  accessibleProjects: [],
  defaultProjectId: '',
  domainId: '',
  domainName: '',
  isProjectForced: false,
  isRegionForced: false,
  language: '',
  displayLanguage: '',
  projectId: '',
  projectName: '',
  region: undefined,
  scope: 'unscope',
  serviceKeyword: 'account',
  token: '',
  userId: '',
  userName: '',
};

export const ROUTE_DEFAULT_STATE: BaseState = {
  status: STATUS_CODE.OK,
  redirect: null,
  env: (process.env.KC_ENV as Env) || 'stage',
  bffEndpoint: process.env.KC_BFF_ENDPOINT || '',
  iamEndpoint: process.env.KC_IAM_ENDPOINT || '',
  iamSSREndpoint: process.env.KC_IAM_SSR_ENDPOINT || '',
  error: null,
  ssrConfig: null,
  language: '',
  displayLanguage: '',
  serviceKeyword: 'account',
};

export const ERROR_PAGE_DEFAULT_STATE: BaseState = {
  status: STATUS_CODE.OK,
  redirect: null,
  env: (process.env.KC_ENV as Env) || 'stage',
  bffEndpoint: process.env.KC_BFF_ENDPOINT || '',
  iamEndpoint: process.env.KC_IAM_ENDPOINT || '',
  iamSSREndpoint: process.env.KC_IAM_SSR_ENDPOINT || '',
  error: null,
  ssrConfig: null,
  language: '',
  displayLanguage: '',
  serviceKeyword: 'account',
};
